import React from 'react'
import _ from 'lodash'
import axios from 'axios'

import getCountryCode from '~/tools/userEnvironment/getCountryCode'

import { addUserProfile, trackEvent } from '~/tools/analytics/cleverTap'
import userStore from '~/redux/user/store'
import { getToken } from '~/redux/user/tokens'
import { signup } from '~/redux/user/actions'
import Cookies from 'js-cookie'

import './style.css'

class CreateLogin extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      selected: null, 
      signupCheckbox: true, 
      signupFormValid: false,
      emailConsent: {},
      emailChecked: null
    }

    this.toggleEmailCheck = this.toggleEmailCheck.bind(this)
  }

  getVal(key){
    return _.get(this.props.metadataMap, key)
 }  

  toggleEmailCheck(e) {
    this.setState({
      emailChecked: e.target.checked
    })
  }

  fetchEmailConsent() {
    let emailConsentUrl = `https://d2tipiv4cs5bo1.cloudfront.net/emailconsent/${window.settings.internalName}.json`
    return axios.get(emailConsentUrl).then( r => {
      let emailConsentConfig = r.data
      
      return getCountryCode().then( countryCode => {
        let config = emailConsentConfig[countryCode] || emailConsentConfig.default || {}
        this.setState({
          emailConsent: config, 
          emailChecked: config.checked
        }) 
      })
    }).catch( e => {
      return 
    })
  }
  
  renderEmailConsent() {
    const { emailConsent, emailChecked } = this.state
    if (!emailConsent.visible)
      return 
    
    return (
      <div className="email-consent">
        <input onChange={this.toggleEmailCheck} type="checkbox" checked={emailChecked}/>
        <div className="copy" dangerouslySetInnerHTML={{__html: emailConsent.copy}}></div>
      </div>
    )
  }

  componentDidMount(){
    this.fetchEmailConsent()
    window.sessionStorage.getItem('offer') && this.checkOfferValidity()
  }

  shouldDisableLogin() {
    if (!this.state.signupFormValid)
      return true
      
    return false
    // if (!this.state.emailConsent.visible)
    //   return false

    // return !this.state.emailChecked
  }

  render() {
    return (
      <div className="signup">
        { this.selectedPlanT() }
        { this.props.user ? this.continueAsUserT() : this.signupFormT() }
      </div>
    )
  }

  selectedPlanT() {
    var { plan, editPlan } = this.props
    const pd = plan.planDetails && plan.planDetails[0] || {}
    if (!plan) return
    var phoneNumber = (window.settings.customerService || {}).phone
    var formattedPhoneNumber = phoneNumber && phoneNumber.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "$1-$2-$3-$4")
    return (
      <div className="selected-plan">
        <div className="title">
          { pd.title || plan.name }
          { editPlan &&<span className="link-button site-color site-border-color edit-plan" onClick={ _ => this.props.editPlan() }>
            {this.getVal('editPlan')}
          </span> }   
        </div>
        <div className="desc">{ editPlan ? this.getVal('planDetail') : '' }</div>
        <div className="details">{ pd.description || plan.description }</div>
        <div className="bottom">
          { this.offerCodeEl() }
          <div className="company">
            { window.settings.companyName } {formattedPhoneNumber && `|${ formattedPhoneNumber }`}
          </div>
        </div>
      </div>
    )
  }

  offerCodeEl() {
    return (
      <div className="code">
        { this.props.offerCode ? (
          <div>
            {this.getVal("billingOfferAppliedLeft")} {this.getVal("billingOfferAppliedRight")} - { this.props.offerCode.displayName || this.props.offerCode.name }<br />
            <span
              className="remove-code-button link-button site-color site-border-color"
              onClick={ _ => this.props.removeCode() }> {this.getVal('removePromo')} </span>
          </div>
        ) : !this.props.editingOfferCode ? ( <div>
          {this.getVal('promoHeading')}
          <span
            className="add-code-button link-button site-color site-border-color"
            onClick={ _ => this.props.editOfferCode(true) }>{this.getVal('addPromo')}</span>
        </div> ) : ( <div>
          <input
            autoFocus
            className="offer-code-input"
            onKeyPress={ e => { if (e.key === 'Enter') this.onClickApply() } }
            ref={ el => this.codeInput = el } />&nbsp;
          <span
            className={'apply link-button site-color site-border-color' + (this.state.postingValidate ? ' processing': '')}
            onClick={ e => this.onClickApply(e) }
            >{this.getVal('applyPromo')}</span>
          &nbsp;
          <span className="remove-code-button link-button site-color site-border-color" onClick={ _ => this.props.editOfferCode(false) }> {this.getVal('cancelPromo')} </span>
        </div> ) }
        <div className="error">{ this.state.offerCodeError } </div>
      </div>
    )
  }

  checkOfferValidity(){
    this.props.editOfferCode(true)
    this.onClickApply()
  }

  onClickApply(e) {
    var offerCode = (this.codeInput && this.codeInput.value.toUpperCase()) || window.sessionStorage.getItem('offer').toUpperCase()

    this.setState({ postingValidate: true })
    return getToken().then(token => {
      return axios({
        method: "POST",
        url: `${window.settings.apiBaseUrl}/subscription/offer/validate`,
        params: { site: window.settings.internalName },
        data: {
          offerCode: offerCode,
          subscriptionPlanId: this.props.plan.id,
          site: window.settings.internalName
        },
        headers: {
          Authorization: token,
          "x-api-key": window.settings.baseAPIKey
        }
      });
    })
    .then( (res, data) => {
      this.props.addCode({
        displayName: res.data.displayName,
        name: res.data.name,
        code: offerCode
      })
    }).catch(err => {
      var message = (((err || {}).response || {}).data || {}).code
      this.setState({...this.state,
        offerCodeError: (this.getVal(message) || this.getVal('promoValidatingError'))
      })
      setTimeout(_ => this.setState({...this.state, offerCodeError: null }), 2000)
    }).then( _ => {
      this.setState({ postingValidate: false })
    })
  }

  continueAsUserT() {
    return (
      <div className="continue">
        <div className="title">{this.getVal('createdAccountHeading')}</div>
        <div className="desc">{this.getVal('createdAccountdesc')}</div>
        <div className="userInfo">
          <div className="head"> {this.getVal('userInfoHeading')} </div>
          <div className="name"> { this.props.user.name }</div>
          <div className="email">{ this.props.user.email } </div>
        </div>
        <div className="terms">
        <div  dangerouslySetInnerHTML={{ __html: this.getVal('createAccountAgreement')}}/>
        </div>
        <div className="continue-button button cta" onClick={ _ => this.props.continue() }>
          {this.getVal('continueCtaText')}
        </div>
      </div>
    )
  }

  signupFormT() {
    const shouldDisableLogin = this.shouldDisableLogin()
    return (
      <form className="signup-form" onSubmit={ e => this.signup(e) }>
        <div className="title">{this.getVal('createAccountHeading')}</div>
        <div className="desc">{this.getVal('createAccountdesc')}</div>
        <div className="inputs">
          <input
            type="email"
            placeholder={this.getVal('createAccountEmail')}
            ref={ el => { this.emailInput = el } }
            onKeyUp={ e => this.onInputChange(e) }
            onFocus={ e => this.onInputChange(e) } required/>
          <input
            type="text"
            placeholder={this.getVal('createAccountName')}
            ref={ el => { this.nameInput = el } }
            onKeyUp={ e => this.onInputChange(e) }
            onFocus={ e => this.onInputChange(e) } required/>

          <div className="password-input">
            <input
              type={ this.state.showPassword ? 'text' : 'password' }
              placeholder={this.getVal('createAccountPassword')}
              ref={ el => { this.passwordInput = el } }
              onKeyUp={ e => this.onInputChange(e) }
              onFocus={ e => this.onInputChange(e) } required/>
            <span
              className="show-password-button"
              onClick={ e => { this.setState({...this.state, showPassword: !this.state.showPassword }) } }>
              <i className="ion-eye"></i>
            </span>
          </div>
        </div>
        {/*<div
          className="signup-checkbox site-color"
          onClick={ e => { this.setState({...this.state, signupCheckbox: !this.state.signupCheckbox }) } }>
          { this.state.signupCheckbox  && (<i className="ion-checkmark"> </i>) }
        </div>
        <div className="signup-text">
          Keep me informed about future updates. You can unsubscribe anytime.
        </div>*/}

        <div className="terms-text">
        <div  dangerouslySetInnerHTML={{ __html: this.getVal('createAccountAgreement')}}/>
        </div>
        
        { this.renderEmailConsent() }
        { window.settings.features.legal_verbiage &&
            <div className="ageCheck terms-text">
              { this.state.ageCheckError && !this.state.ageIsChecked && 
                <div className="ageCheckError">{this.state.ageCheckError}</div> 
              }
              <input 
                name="ageCheck"
                type="checkbox" 
                id="ageCheck" 
                onClick={() => this.setState({
                  ageIsChecked:!this.state.ageIsChecked, 
                  ageCheckError:null
                })}                  
              />
              <label htmlFor="ageCheck">{window.settings.features.legal_verbiage_copy}</label>
            </div>
          }
        <input
          className={
            'button ' +
            (shouldDisableLogin ? ' inactive' : 'site-background-color') +
            (this.state.signupProcessing ? ' processing' : '')
          }
          type="submit"
          value={window.settings.serviceType === 'SVOD'? this.getVal('createAccountSubscribe') : this.getVal('createAccountSignUp')} />

        <div className={ 'error-text site-color' + (this.state.signupAlertText ? ' shown' : '')  }>
          { this.state.signupAlertText }
        </div>

        <div className="already-account">
          {this.getVal('createdAccountAlready')}
          &nbsp;
          <span 
            className="link-button site-color site-border-color" 
            onClick={ _ => this.props.goToLogin() }
          >{this.getVal('signInCta')}</span>
        </div>
      </form>
    )
  }

  onInputChange(e) {
    const errorTextBox = document.getElementsByClassName('error-text')
    const atPassword = e.currentTarget.type.indexOf('password') !== -1

    let password = this.passwordInput.value;
    if(password.length > 0) {
      errorTextBox[0].classList.add('shown')
      if(password.length < 5 || password.length > 50){
        errorTextBox[0].textContent = 'Password should be between 5 and 50 characters'
        this.setState({...this.state, signupFormValid: false})
        return false;
      }
      errorTextBox[0].textContent= ''
      errorTextBox[0].classList.remove('shown')
    }

    this.setState({...this.state, signupFormValid: this.nameInput.value && this.emailInput.value && this.passwordInput.value})
    if(!atPassword) {
      errorTextBox[0].classList.remove('shown')
    }

  }

  enableButton(){
    var signupFormValid = this.nameInput.value && this.emailInput.value && this.passwordValid
    if (signupFormValid !== this.state.signupFormValid)
      this.setState({...this.state, signupFormValid: signupFormValid})
  }

  signup(e) {
    e.preventDefault()
    const element = document.getElementById('ageCheck')
    if(element){
      const ageCheck = element.checked
      if (!ageCheck){
        this.setState({ageCheckError:window.settings.features.legal_verbiage_error})
        return
      }
    }


    this.setState({ signupProcessing: true, signupAlertText: '' })
    var user = {
      name: this.nameInput.value,
      email: this.emailInput.value,
      password: this.passwordInput.value,
      emailConsent: this.state.emailConsent.visible ? this.state.emailChecked : undefined
    }

    userStore
      .dispatch(signup(user))
      .then( _ => {
        this.setState({ signupProcessing: false })
        //Signup Personalization
        Cookies.set('isUserSignUp', true);
        
        var userInfo = this.props.user
        addUserProfile('Site', {
          'Name': userInfo.name,
          'Email': userInfo.email,
          'Identity': userInfo.userId,
          'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
        })
        trackEvent('Signed Up', {registrationType: 'Native'})
        setTimeout(_ => this.props.continue(), 200)
      })
      .catch(error => {
        this.setState({ signupProcessing: false })

        var message =
          (((error || {}).response || {}).data || {}).error ||
          'There was an error processing your request.'
        this.signupAlert(message)
      })
  }

  signupAlert(txt) {
    this.setState({...this.state, 'signupAlert': true, signupAlertText: txt })
  }
}

export default CreateLogin;